// Date / time formatting helpers.

// ISO datetime → e.g. "November 14, 1:14 AM" (pass 'short' for "Nov 14, …").
export function formatDateTime(iso: string, month: 'long' | 'short' = 'long') {
  return new Intl.DateTimeFormat(undefined, {
    month,
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(iso));
}

// Time scalar "HH:MM:SSZ" (e.g. "13:00:00Z") → "1:00PM".
export function formatTime(time: string) {
  const [hh, mm] = time.split(':');
  const hour = parseInt(hh, 10);
  const suffix = hour >= 12 ? 'PM' : 'AM';
  const twelve = hour % 12 || 12;
  return `${twelve}:${mm}${suffix}`;
}
